import AdminHeader from "@/components/common/AdminHeader";
import TrailOfferList from "@/components/trail-offer/TrailOffers";

export default function TrailOfferPage() {
  return (
    <div className="min-h-screen bg-gray-50">
      <AdminHeader />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 py-6 sm:py-8">
        <TrailOfferList />
      </main>
    </div>
  );
}
